import type { AdminAnnouncementEmailTemplateDefinition } from "./types";
import {
    formatListBlock,
    joinBlocks,
    splitLines,
} from "./utils";

export const promotionTemplate: AdminAnnouncementEmailTemplateDefinition = {
    key: "PROMOTION",
    label: "Promotion",
    description:
        "A campaign-oriented layout for offers, discount codes, and limited-time incentives.",
    recommendedAnnouncementType: "PROMOTION",
    messageLabel: "Offer Details *",
    messagePlaceholder:
        "Describe the offer, the value to the rider or driver, and why they should care now.",
    previewEyebrow: "Promotional Email",
    previewHeaderClassName:
        "bg-[linear-gradient(135deg,#16a34a_0%,#22c55e_45%,#14532d_100%)]",
    previewBadgeClassName:
        "bg-emerald-100 text-emerald-700 dark:bg-emerald-900/30 dark:text-emerald-300",
    fields: [
        {
            id: "offerCode",
            label: "Offer Code",
            type: "text",
            placeholder: "SAVE20",
        },
        {
            id: "redeemSteps",
            label: "How To Redeem",
            type: "textarea",
            placeholder: "One step per line",
            rows: 4,
        },
        {
            id: "terms",
            label: "Terms",
            type: "textarea",
            placeholder: "One term per line",
            rows: 4,
        },
    ],
    buildBody: ({ message, fields }) =>
        joinBlocks([
            message,
            fields.offerCode?.trim()
                ? `Offer code: ${fields.offerCode.trim()}`
                : null,
            fields.redeemSteps
                ? formatListBlock("How to redeem", fields.redeemSteps)
                : null,
            fields.terms ? formatListBlock("Terms", fields.terms) : null,
        ]),
    buildPreviewSections: ({ message, fields }) => [
        {
            label: "Offer",
            body: message,
            tone: "default",
        },
        ...(fields.offerCode?.trim()
            ? [
                  {
                      label: "Code",
                      body: fields.offerCode.trim(),
                      tone: "accent" as const,
                  },
              ]
            : []),
        ...(splitLines(fields.redeemSteps || "").length > 0
            ? [
                  {
                      label: "How To Redeem",
                      body: splitLines(fields.redeemSteps || "").join("\n"),
                      tone: "muted" as const,
                      list: true,
                  },
              ]
            : []),
        ...(splitLines(fields.terms || "").length > 0
            ? [
                  {
                      label: "Terms",
                      body: splitLines(fields.terms || "").join("\n"),
                      tone: "muted" as const,
                      list: true,
                  },
              ]
            : []),
    ],
};
